import {LANGUAGE} from '@/common/utils/constants';

export const SAVED_PROJECTS = {
	[LANGUAGE.en.short]: {
		savedProjects: {
			tooltips: {
				removeProject: "Remove from saved",
				save: "Save"
			},
			removed: "Removed from Saved Projects",
			emptySections: "You don’t have any saved projects.",
			confidential: "Customer's name is confidential."
		},
	},
	[LANGUAGE.de.short]: {
		savedProjects: {
			tooltips: {
				removeProject: "Aus der Liste entfernen",
				save: "Gespeichert"
			},
			removed: "Aus gespeicherten Projekten entfernt",
			emptySections: "Sie haben keine gespeicherten Projekte.",
			confidential: "Der Name des Kunden ist vertraulich."
		},
	},
	[LANGUAGE.fr.short]: {
		savedProjects: {
			tooltips: {
				removeProject: "Supprimer des éléments sauvegardés",
				save: "Enregistrés"
			},
			emptySections: "Vous n'avez aucun projet enregistré.",
			confidential: "Le nom du client est confidentiel."
		},
	},
	[LANGUAGE.it.short]: {
		savedProjects: {
			tooltips: {
				removeProject: "Rimuovi dai salvati",
				save: "Salvato"
			},
			removed: "Supprimé des projets enregistrés",
			emptySections: "Non hai progetti salvati.",
			confidential: "Il nome del cliente è riservato."
		},
	},
	[LANGUAGE.ja.short]: {
		savedProjects: {
			tooltips: {
				removeProject: "保存済みから削除",
				save: "保存済み"
			},
			removed: "保存済みプロジェクトから削除",
			emptySections: "保存したプロジェクトはありません。",
			confidential: "お客様のお名前は非公開です。"
		},
	},
	[LANGUAGE.es.short]: {
		savedProjects: {
			tooltips: {
				removeProject: "Eliminar de guardados",
				save: "Guardado"
			},
			removed: "Eliminado de Proyectos Guardados",
			emptySections: "No tienes ningún proyecto guardado.",
			confidential: "El nombre del cliente es confidencial."
		},
	}
}
